module.exports = __webpack_public_path__ + "img/banner-sp.46bca206.jpg";